// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* Custom styles to enhance Bootstrap */
.card {
  border: 1px solid #e9ecef;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
}

.card:hover {
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  transition: box-shadow 0.15s ease-in-out;
}

.font-monospace {
  font-family: 'Courier New', Courier, monospace;
}

.border-subtle {
  border-color: #e9ecef !important;
}

.bg-light-subtle {
  background-color: #f8f9fa;
}

/* Add this to your CSS file */

.order-items-scroll {
  max-height: 90px; /* Adjust height to fit your design */
  overflow-y: auto;
  scrollbar-width: thin; /* Firefox */
  scrollbar-color: #888 #f0f0f0; /* Firefox (thumb and track color) */
}

/* Custom Scrollbar for Webkit Browsers (Chrome, Safari, Edge) */
.order-items-scroll::-webkit-scrollbar {
  width: 8px; /* Set scrollbar width */
}

.order-items-scroll::-webkit-scrollbar-thumb {
  background-color: #888;
  border-radius: 4px; /* Rounded corners for the scrollbar thumb */
}

.order-items-scroll::-webkit-scrollbar-track {
  background-color: #f0f0f0; /* Track color */
}

.order-items-scroll::-webkit-scrollbar-thumb:hover {
  background-color: #555; /* Darker thumb on hover */
}

.order-items-scroll::-webkit-scrollbar-track:hover {
  background-color: #e0e0e0; /* Lighter track on hover */
}

`, "",{"version":3,"sources":["webpack://./src/containers/Orders/OrderDetails.css"],"names":[],"mappings":";AACA,uCAAuC;AACvC;EACE,yBAAyB;EACzB,mDAAmD;AACrD;;AAEA;EACE,6CAA6C;EAC7C,wCAAwC;AAC1C;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,8BAA8B;;AAE9B;EACE,gBAAgB,EAAE,qCAAqC;EACvD,gBAAgB;EAChB,qBAAqB,EAAE,YAAY;EACnC,6BAA6B,EAAE,oCAAoC;AACrE;;AAEA,gEAAgE;AAChE;EACE,UAAU,EAAE,wBAAwB;AACtC;;AAEA;EACE,sBAAsB;EACtB,kBAAkB,EAAE,4CAA4C;AAClE;;AAEA;EACE,yBAAyB,EAAE,gBAAgB;AAC7C;;AAEA;EACE,sBAAsB,EAAE,0BAA0B;AACpD;;AAEA;EACE,yBAAyB,EAAE,2BAA2B;AACxD","sourcesContent":["\n/* Custom styles to enhance Bootstrap */\n.card {\n  border: 1px solid #e9ecef;\n  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);\n}\n\n.card:hover {\n  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);\n  transition: box-shadow 0.15s ease-in-out;\n}\n\n.font-monospace {\n  font-family: 'Courier New', Courier, monospace;\n}\n\n.border-subtle {\n  border-color: #e9ecef !important;\n}\n\n.bg-light-subtle {\n  background-color: #f8f9fa;\n}\n\n/* Add this to your CSS file */\n\n.order-items-scroll {\n  max-height: 90px; /* Adjust height to fit your design */\n  overflow-y: auto;\n  scrollbar-width: thin; /* Firefox */\n  scrollbar-color: #888 #f0f0f0; /* Firefox (thumb and track color) */\n}\n\n/* Custom Scrollbar for Webkit Browsers (Chrome, Safari, Edge) */\n.order-items-scroll::-webkit-scrollbar {\n  width: 8px; /* Set scrollbar width */\n}\n\n.order-items-scroll::-webkit-scrollbar-thumb {\n  background-color: #888;\n  border-radius: 4px; /* Rounded corners for the scrollbar thumb */\n}\n\n.order-items-scroll::-webkit-scrollbar-track {\n  background-color: #f0f0f0; /* Track color */\n}\n\n.order-items-scroll::-webkit-scrollbar-thumb:hover {\n  background-color: #555; /* Darker thumb on hover */\n}\n\n.order-items-scroll::-webkit-scrollbar-track:hover {\n  background-color: #e0e0e0; /* Lighter track on hover */\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
